module.exports = __webpack_public_path__ + "img/8ed4a60.jpg";